import { roundTo } from '../../helpers/validators/validate.js';
export function sortPortfolio() {
    var sortby = localStorage.getItem('orderby') ? localStorage.getItem('orderby') : 'name';
    var sortdir = localStorage.getItem('sortMethod') ? localStorage.getItem('sortMethod') : 'asc';

    if (userassets.length == 0) return;

    var sort_method = 'alphabetical';
    if (sortdir == 'desc' && sortby == 'name') userassets.sort(function (a, b) { return (a.name.toLowerCase() < b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() < a.name.toLowerCase()) ? -1 : 0); });
    if (sortdir == 'asc' || sortby != 'name') userassets.sort(function (a, b) { return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0); });

    switch (sortby) {
        case 'lastPrice':
            sort_method = 'numerical';
            break;
        case 'startprice':
            sort_method = 'numerical';
            break;
        case 'totalAmount':
            userassets.map(function (e) { e.totalAmount = e.amount * e.lastPrice; });
            sort_method = 'numerical';
            break;
        case 'invest':
            sort_method = 'numerical';
            userassets.map(function (e) { e.invest = e.amount * e.startprice; });
            break;
        case 'result':
            sort_method = 'numerical-result';
            userassets.map(function (e) { e.result = e.startprice > 0 && e.amount > 0 ? (e.amount * e.lastPrice) - (e.amount * e.startprice) : 'NAN'; });
            break;
        case 'resultPercentage':
            sort_method = 'numerical-portfolio';
            userassets.map(function (e) { e.resultPercentage = e.startprice > 0 && e.amount > 0 ? ((e.lastPrice / e.startprice) - 1) * 100 : 'NAN'; });
            break;
    }

    // non-numeric sort
    if (sort_method == 'numerical') {
        if (sortdir == 'desc') userassets.sort(function (a, b) { return (parseFloat(a[sortby]) < parseFloat(b[sortby])) ? 1 : ((parseFloat(b[sortby]) < parseFloat(a[sortby])) ? -1 : 0); });
        if (sortdir == 'asc') userassets.sort(function (a, b) { return (parseFloat(a[sortby]) > parseFloat(b[sortby])) ? 1 : ((parseFloat(b[sortby]) > parseFloat(a[sortby])) ? -1 : 0); });
    }
    if (sort_method == 'numerical-portfolio' || sort_method == 'numerical-result') {
        let _userassets = null;
        let __userassets = null;
        if (sort_method == 'numerical-portfolio') {
            _userassets = userassets.filter(function (e) { return e.resultPercentage != 'NAN'; });
            __userassets = userassets.filter(function (e) { return e.resultPercentage == 'NAN'; });
        } else {
            _userassets = userassets.filter(function (e) { return e.result != 'NAN'; });
            __userassets = userassets.filter(function (e) { return e.result == 'NAN'; });
        }
        if (sortdir == 'desc') _userassets.sort(function (a, b) { return (parseFloat(a[sortby]) < parseFloat(b[sortby])) ? 1 : ((parseFloat(b[sortby]) < parseFloat(a[sortby])) ? -1 : 0); });
        if (sortdir == 'asc') _userassets.sort(function (a, b) { return (parseFloat(a[sortby]) > parseFloat(b[sortby])) ? 1 : ((parseFloat(b[sortby]) > parseFloat(a[sortby])) ? -1 : 0); });
        userassets = _userassets.concat(__userassets);
    }
}

export function updateDOMPortfolioDataByIndex(index, data, animate) {

    /* calc exchange ration */
    var ratio = 1;
    if (data.currency == 'EUR') { ratio = userCurExRates.ratioEURToUserCur; data.currency = '€'; }
    if (data.currency == 'USD') { ratio = userCurExRates.ratioUSDToUserCur; data.currency = '$'; }

    var object = $('#portfolioCard_' + index);

    if (!!object) {

        object.find('.result-indicator').each(function () {
            $(this).css('display', 'none');
            if (parseFloat(data.amount) > 0) $(this).css('display', 'block');
        });

        object.find('.loading-nona').removeClass('loading-nona');

        $('.thousand-spacer').each(function () {
            $(this).removeClass('parsedValue');
        });

        if (data.lastPrice != '-') data.lastPrice = parseFloat(data.lastPrice);
        if (data.delta) data.delta = parseFloat(data.delta);

        /* disabled asset part */
        object.css('opacity', '1');
        object.find($('div')).each(function () {
            var attr = $(this).attr('data-toggle');
            if (typeof attr !== typeof undefined && attr !== false) {
                $(this).attr('data-toggle', 'collapse');
            }
        });
        object.find($('.edit-icons')).find($('.row')).first().css('display', 'block');
        object.removeClass('disabled-asset');

        if (!data.enabled && data.enabled !== undefined) {
            object.css('opacity', '0.5');
            object.find($('div')).each(function () {
                var attr = $(this).attr('data-toggle');
                if (typeof attr !== typeof undefined && attr !== false) {
                    $(this).attr('data-toggle', '');
                }
            });
            object.find($('.edit-icons')).find($('.row')).first().css('display', 'none');
            //object.find($(".edit-icons")).find($(".row")).first().find($("div")).first().html("");
            object.addClass('disabled-asset');

        }

        /* MO - set asset name */
        object.find('.art-nameLong').each(function () {
            var badApiStatus = '';
            var badApiStatusMsg = '';
            var titleText = data.name;
            if (data.isin) titleText += ' ' + '| ISIN: ' + data.isin + ' ';
            if (data.wkn) titleText += '| WKN: ' + data.wkn;
            $(this).attr('title', titleText);
            $(this).html(data.name + badApiStatus + '<!-- ' + data.id + ' -->');
            $(this).addClass(data.id);
        });
        object.find('.trending-up-or-down').each(function () {
            $(this).removeClass('wa-green');
            $(this).removeClass('wa-red');
            $(this).removeClass('mdi-trending-up');
            $(this).removeClass('mdi-trending-down');
            if (data.fiftyDayAverage && data.lastPrice >= data.fiftyDayAverage) {
                $(this).addClass('mdi-trending-up');
                $(this).addClass('wa-green');
            } else if (data.fiftyDayAverage && data.lastPrice < data.fiftyDayAverage) {
                $(this).addClass('mdi-trending-down');
                $(this).addClass('wa-red');
            }
            /* für MAX: realdelta.falling (nicht in data.) -> woher bekommen, um dann trending-down oder up zu machen? */
            //$(this).addClass('mdi-trending-up');
            //$(this).addClass('wa-green');

        });

        /* set last price */
        if (data.currency && data.lastPrice) {
            object.find('.lastPrice').each(function () {
                var dec = 2;
                if (data.assettype == 'CoreCryptoAsset' && data.lastPrice < 100) dec = 4;
                if (data.lastPrice != '-') $(this).html(roundTo(data.lastPrice, dec) + ' ' + data.currency);
                else $(this).html('-');

                if (data.timestampAssetValues) {
                    var d = new Date(data.timestampAssetValues);
                    var day = ('0' + d.getDate()).slice(-2);
                    var month = ('0' + (d.getMonth() + 1)).slice(-2);
                    var year = d.getFullYear();
                    $(this).attr('title',(I18n['asset_last_price']) + ':'  + ' ' + day + '.' + month + '.' + year );
                }

                if ($(this).hasClass('text-normal-red'))
                    $(this).removeClass('text-normal-red');
            });
        }
        if (!data.lastPrice) {
            object.find('.lastPrice').each(function () {
                $(this).html(I18n['no_data']);
                if (!$(this).hasClass('text-normal-red'))
                    $(this).addClass('text-normal-red');
            });
        }
        

        object.find('.assetNote').each(function () {
            $(this).attr('data-asset-id', data.id);
            if ($(this).is('textarea, input')) {
                $(this).val('');
            } else {
                $(this).text('');
            }
        });
        object.find('.assetNoteSymbol.small').each(function () {
            $(this).css('display', 'none');
        });

        object.find('.art-stockname').each(function () {
            /* MO */
            if (!data.symbol) data.symbol = '-';
            var namestring = data.symbol.toUpperCase();
            if (data.isin) namestring += ' <small> - ISIN: ' + data.isin + '</small>';
            if (data.wkn) namestring += ' <small> - WKN: ' + data.wkn + '</small>';
            $(this).html(namestring + '<!-- ' + data.id + ' -->');
        });

        /* cleanup portfolio details : */
        object.find('.toggle-arrow').each(function () {
            $(this).removeClass('wa-bg-red');
            $(this).removeClass('wa-bg-green');
        });
        object.find('.art-startprice').each(function () {
            $(this).html('');
        });
        object.find('.art-endprice').each(function () {
            $(this).html('');
        });
        object.find('.art-startprice-label').each(function () {
            $(this).html('');
        });
        object.find('.art-endprice-label').each(function () {
            $(this).html('');
        });
        object.find('.art-amount').each(function () {
            $(this).html('');
        });
        object.find('.art-amount-label').each(function () {
            $(this).html('');
        });
        object.find('.art-amount2').each(function () {
            $(this).html('');
        });
        object.find('.art-current2').each(function () {
            $(this).html('');
            $(this).removeClass('wa-green');
            $(this).removeClass('wa-red');
        });
        object.find('.art-current2-label').each(function () {
            $(this).html('');
        });
        object.find('.art-invest').each(function () {
            $(this).html('');
        });
        object.find('.art-invest-label').each(function () {
            $(this).html('');
        });

        object.find('.art-result1-abs').each(function () {
            $(this).removeClass('wa-red');
            $(this).removeClass('wa-green');
            $(this).html('');
        });
        object.find('.art-result1-perc').each(function () {
            $(this).removeClass('wa-red');
            $(this).removeClass('wa-green');
            $(this).html('');
        });
        object.find('.art-result1-label').each(function () {
            $(this).html('');
        });
        object.find('.art-area').each(function () {
            $(this).css('display', 'none');
        });

        object.find('.art-myassetvalue').each(function () {
            $(this).html('');
        });
        object.find('.art-myassetvalue-label').each(function () {
            $(this).html('');
        });

        object.find('.art-taken-profits').each(function () {
            $(this).html('');
        });
        object.find('.art-taken-profits-label').each(function () {
            $(this).html('');
        });

        /* User Asset Marker and data*/
        var hasTrades = parseFloat(data.amount) + parseFloat(data.amount_sold) > 0 ? true : false;
        var userAssetMarkerColor = 'none';
        if (data.lastPrice && data.lastPrice != '-' && hasTrades) {

            /* Collapsed Data headings */
            object.find('.art-startprice').each(function () {
                let dec = 2;
                if (data.assettype == 'CoreCryptoAsset' && data.startprice < 100) dec = 4;
                let result = roundTo(data.startprice, dec);
                //$(this).html(result * ratio + " " + userCurExRates.userCurSymbol);
                $(this).html(result + ' ' + data.currency);

            });
            object.find('.art-startprice-label').each(function () {
                $(this).html(I18n['my_entry_course'] + ': ');
            });

            object.find('.art-endprice').each(function () {
                let dec = 2;
                if (data.assettype == 'CoreCryptoAsset' && data.endprice < 100) dec = 4;
                let result = roundTo(data.endprice, dec);
                //$(this).html(result * ratio + " " + userCurExRates.userCurSymbol);
                $(this).html(result + ' ' + data.currency);

            });
            object.find('.art-endprice-label').each(function () {
                $(this).html(I18n['my_endprice_course'] + ': ');
            });

            var ounce = '';
            if (data.assettype == 'CoreCommodityAsset') ounce = ' oz';
            object.find('.art-amount').each(function () {
                $(this).html(data.amount + ounce);
            });
            object.find('.art-amount-label').each(function () {
                $(this).html(I18n['amount'] + ': ');
            });
            /* MO */
            var parsed_amount = parseFloat(data.amount).toFixed(0);
            if (data.amount % 1 != 0) {
                parsed_amount = parseFloat(data.amount).toFixed(1);
            }

            object.find('.art-amount2').each(function () {
                $(this).html("<small class='pl-1 pr-1 text-center' style='min-width: 50px;display: inline-block;'>x " + parsed_amount + '</small>');
                $(this).attr('title', I18n['asset_amount']);
            });
            /* MO */
            object.find('.art-current2').each(function () {
                let dec = 2;
                if (data.assettype == 'CoreCryptoAsset' && data.lastPrice < 100) dec = 4;
                let result = roundTo(data.lastPrice, dec);
                //if (data.lastPrice != "-") $(this).html(result * ratio + " " + userCurExRates.userCurSymbol);
                if (data.lastPrice != '-') $(this).html(result + ' ' + data.currency);
                else $(this).html('-');
                var color;
                if (result > parseFloat(data.startprice))
                    color = 'wa-green';
                else
                    color = 'wa-red';
                $(this).addClass(color);
            });
            object.find('.art-current2-label').each(function () {
                $(this).html(I18n['portfolio_current'] + ': ');
            });
            /* MO */
            object.find('.art-invest').each(function () {
                var invest = (parseFloat(data.startprice) * parseFloat(data.amount)).toFixed(2);
                //$(this).html(invest * ratio + " " + userCurExRates.userCurSymbol);
                $(this).html(invest + ' ' + data.currency);
            });
            object.find('.art-invest-label').each(function () {
                var invest = (parseFloat(data.startprice) * parseFloat(data.amount)).toFixed(2);
                $(this).html(I18n['portfolio_my_invest'] + ': ');
            });

            if (parseFloat(data.startprice) < parseFloat(data.lastPrice)) {

            }

            userAssetMarkerColor = 'wa-bg-red';
            object.find('.art-result1-abs').each(function () {
                var result = ((data.lastPrice - parseFloat(data.startprice)) * parseFloat(data.amount));
                var taken_profits = (data.endprice - data.startprice) * data.amount_sold;
                result = result + taken_profits;
                result = result.toFixed(2);
                var color;

                if (result > 0) {
                    color = 'wa-green';
                    userAssetMarkerColor = 'wa-bg-green';
                } else {
                    color = 'wa-red';
                }
                $(this).html(result + ' ' + data.currency);
                $(this).addClass(color);
            });

            object.find('.toggle-arrow').each(function () {
                $(this).addClass(userAssetMarkerColor);
            });

            object.find('.art-result1-perc').each(function () {
                if (data.amount > 0) {
                    var relResult = roundTo(((parseFloat(data.lastPrice) / parseFloat(data.startprice)) - 1) * 100, 1);
                    var color;
                    var label;
                    if (relResult > 0){
                        color = 'wa-green';
                        label = I18n['asset_current_gain'];
                    }else{
                        color = 'wa-red';
                        label = I18n['asset_current_loss'];
                    }
                    $(this).html('(' + relResult + '%)');
                    $(this).addClass(color);
                    $(this).attr('title', label);
                }
            });
            object.find('.art-result1-label').each(function () {
                $(this).html(I18n['portfolio_profit'] + ': ');
            });

            object.find('.art-area').each(function () {
                $(this).css('display', 'block');
            });

            object.find('.art-myassetvalue').each(function () {
                var myassetvalue = data.amount * data.lastPrice;
                var dec = 2;
                if (data.assettype == 'CoreCryptoAsset' && myassetvalue < 100) dec = 4;
                myassetvalue = roundTo(myassetvalue, dec);
                $(this).html(myassetvalue + ' ' + data.currency);
                $(this).attr('title',I18n['asset_total_value']);
            });
            object.find('.art-myassetvalue-label').each(function () {
                $(this).html(I18n['portfolio_totalAmount'] + ': ');
            });

            object.find('.art-taken-profits').each(function () {
                var taken_profits = (data.endprice - data.startprice) * data.amount_sold;
                var dec = 2;
                if (data.assettype == 'CoreCryptoAsset' && taken_profits < 100) dec = 4;
                taken_profits = roundTo(taken_profits, dec);
                $(this).html(taken_profits + ' ' + data.currency);
            });
            object.find('.art-taken-profits-label').each(function () {
                $(this).html(I18n['portfolio_realizedProfits'] + ': ');
            });

        } else {

        }

        object.find('.asset-alerts').each(function () {
            var _this = $(this);
            var num_html = '';
            var alert_count = 0;
            var active_count = 0;
            var alert_active = false;
            useralerts.forEach(function (alert) {
                if (alert.asset_id == data.id) {
                    var cell_strings = build_alert_string(alert.type, alert.delta, alert.timeframe, alert.realdelta, alert.lessthan,
                        alert.absolutevalue, alert.currency, data.lastPrice,
                        data.twoHundredDayAverage, data.fiftyDayAverage, alert.alert_on_avg_200, alert.alert_on_avg_50);
                    var parseData = {
                        index: alert.id,
                        delta_cell: cell_strings[0],
                        current_value_cell: cell_strings[1],
                        alert_warning: alert.active && alert.enabled ? 'block' : 'none',
                        active_alert: alert.active && alert.enabled ? 'active-alert' : 'nonactive-alert'
                    };
                    var rowTemplate = _.template(template_alerts_on_portfolio);
                    var compiledTemplate = rowTemplate({ data: parseData });
                    var html = $.parseHTML(compiledTemplate);
                    $(_this).append(html);
                    if (alert.active) num_html += "<span style='color:" + '#73EA79' + "'>■</span>";
                    else num_html += "<span style='color:" + '#3178c4' + "'>■</span>";
                    alert_count += 1;
                    if (alert.active){
                        alert_active = true;
                        active_count +=1;
                    };
                }
            });
            var html = '<div id="addsame-' + index + '" class="addsame-asset hover-mini-alert col-6 col-md-4 col-lg-4 alert-card" style="padding:1px;padding-top:0px; cursor:pointer" title="' + I18n['create_alert_header'] + '"><div class="add-alert-inner nonactive-alert asset-indicator-left card" style="">';
            html += '<span><i class="mdi main-txt-color mdi-bell-outline" style="font-size:20px"></i><i style="font-size:20px" class="mdi mdi-library-plus"></i></button>';
            html += '</div></div>';
            $(_this).append(html);
            object.find('.alertCount').each(function () {
                $(this).html('');
            });
            object.find('.alertSymbol').each(function(){
                $(this).attr('title', alert_count + ' ' + (alert_count === 1 ? I18n['asset_alert']: I18n['asset_alerts']));
            });

            object.find('.alertSymbol').each(function () {
                $(this).removeClass('mdi-bell-outline');
                $(this).removeClass('mdi-bell-ring-outline');
                $(this).removeClass('wa-red');
            });
            object.find('.nonactive-asset').each(function () {
                $(this).addClass('nonactive-asset');
                $(this).removeClass('active-asset');
            });
            object.find('.active-asset').each(function () {
                $(this).removeClass('active-asset');
                $(this).addClass('nonactive-asset');
            });
            if (alert_count > 0) {
                object.find('.alertCount').each(function () {
                    $(this).html(alert_count);
                });
                object.find('.alertSymbol').each(function () {
                    $(this).addClass('mdi-bell-outline');
                });
                if (alert_active) {
                    object.find('.alertSymbol').each(function () {
                        $(this).removeClass('mdi-bell-outline');
                        $(this).addClass('mdi-bell-ring-outline');
                        $(this).removeClass('main-txt-color');
                        $(this).addClass('wa-red');
                        $(this).attr('title', I18n['asset_count'] + ' ' + '1' + ' ' +  I18n['asset_active_alert'] + ' ' + alert_count + ' ' +  I18n['asset_alerts']);
                    });
                    object.find('.alert-warning2.block').each(function () {
                        $(this).css('display', 'none');
                    });
                    object.find('.nonactive-asset').each(function () {
                        $(this).removeClass('nonactive-asset');
                        $(this).addClass('active-asset');
                    });
                }
            }
        });

        var objectJS = document.getElementById('portfolioCard_' + index);
        if (objectJS) {
            objectJS.addEventListener('animationiteration', function endload(e) {
                object.addClass('loading-end');
                object.removeClass('loading');
                objectJS.removeEventListener('animationiteration', endload);
                setTimeout(function () {
                    object.removeClass('loading-end');
                }, 0);
            }
                , false);
        }
        if (animate) {
            object.find('.card-body').css('opacity', '1');
            object.find('.card-body').css('display', 'none');
            object.find('.alert-row').css('opacity', '1');
            object.find('.card-body').fadeIn(400);
        } else {
            object.find('.card-body').css('opacity', '1');
            object.find('.card-body').css('display', 'block');
            object.find('.alert-row').css('opacity', '1');
            object.find('.card-body').fadeIn(0);
        }
    }
}

export function build_alert_string(type, delta, timeframe, realdelta, lessthan, absolutevalue, currency, lastPrice, twoHundredDayAverage, fiftyDayAverage, alert_on_avg_200, alert_on_avg_50) {
    var string = new Array();

    if (currency == 'EUR') currency = '€';
    if (currency == 'USD') currency = '$';

    if (type == 'Alertdelta') {
        var deltaRound;
        if (delta % 1 == 0) {
            deltaRound = roundTo(delta, 0);
        } else {
            deltaRound = roundTo(delta, 2);
        }
        string[0] = 'Δ ';
        if (delta > 0) string[0] += '+';
        string[0] += "<span class='thousand-spacer'>" + deltaRound + "</span>";
        string[0] += '%<br>';
        string[0] += 'in ' + timeframe + ' ' + I18n['days_lc'];

        if (realdelta) {
            var falling_value = parseFloat(realdelta.falling);
            if (falling_value < 0) falling_value *= -1;
            var first = 'color-nonactive';
            var second = 'color-up';
            if (falling_value > parseFloat(realdelta.rising)) {
                first = 'color-down';
                second = 'color-nonactive';
            }

            string[1] = "<font style='padding-left:4px;' class='" + first + "'>-&Delta;&nbsp;";
            string[1] += "<span class='thousand-spacer'>" + roundTo(falling_value, 1) + "</span>";
            string[1] += '%</font><br>';
            string[1] += "<font class='" + second + "'>+&Delta;&nbsp;";
            string[1] += "<span class='thousand-spacer'>" + roundTo(parseFloat(realdelta.rising), 1) + "</span>";
            string[1] += '%</font>';

        } else {
            string[1] = "<font class='text-normal-red'>" + I18n['no_data'] + '</font>';
        }
    }
    if (type == 'Alertabsolute') {
        if (parseFloat(absolutevalue) % 1 == 0) {
            absolutevalue = roundTo(parseFloat(absolutevalue), 0);
        } else {
            absolutevalue = roundTo(parseFloat(absolutevalue), 2);
        }

        string[0] = '';
        if (lessthan) string[0] += '&lt;';
        else string[0] += '&gt;';
        string[0] += "<span class='thousand-spacer'>" + absolutevalue + "</span>";
        string[0] += ' ' + currency;

        string[1] = '-';
        if (lastPrice != '-') {
            string[1] = '&Delta;&nbsp;';
            delta = roundTo(parseFloat(lastPrice) - parseFloat(absolutevalue), 2);
            if (delta < 0) delta *= -1;
            string[1] += "<span class='thousand-spacer'>" + delta + "</span>";
            string[1] += ' ' + currency;
        }
    }
    if (type == 'Alertkpi') {

        var twoHundredDayAveragePercent = 0;
        var fiftyDayAveragePercent = 0;

        if (lastPrice) {
            twoHundredDayAverage = parseFloat(twoHundredDayAverage);
            twoHundredDayAveragePercent = ((lastPrice - twoHundredDayAverage) / lastPrice) * -100;
            fiftyDayAverage = parseFloat(fiftyDayAverage);
            fiftyDayAveragePercent = ((lastPrice - fiftyDayAverage) / lastPrice) * -100;
        }

        if (alert_on_avg_200) {
            string[0] = '<div class="dlk-radio"><div class="">\
                            <i class="btn-line200 p-2 fa fa-check glyphicon glyphicon-ok">200d</i>\
                        </div></div>';

            string[1] = '\
                    <span class="thousand-spacer">'+ twoHundredDayAverage.toFixed(2) + ' ' + currency + '</span>\
                        <br>\
                        <span class="thousand-spacer">'+ twoHundredDayAveragePercent.toFixed(2) + ' %</span>\
                    ';
        }

        if (alert_on_avg_50) {
            string[0] = '<div class="dlk-radio"><div class="">\
                            <i class="btn-line50 p-2 fa fa-check glyphicon glyphicon-ok">50d</i>\
                        </div></div>';

            string[1] = '\
                    <span class="thousand-spacer">'+ fiftyDayAverage.toFixed(2) + ' ' + currency + '</span>\
                        <br>\
                        <span class="thousand-spacer">'+ fiftyDayAveragePercent.toFixed(2) + ' %</span>\
                    ';
        }
    }
    return string;
}
